import { MarketAsset } from "./market-asset";

export type MarketAssetMeta = typeof MarketAssetMeta.Type;
export type MarketAssetMetaEncoded = typeof MarketAssetMeta.Encoded;

export const MarketAssetMeta = MarketAsset.pick(
  "marketAddress",
  "protocolKey",
  "chainKey",

  "tokenAddress",
  "rawSymbol",
  "rawName",
  "decimals",
  "isNative",

  "assetKey",
  "priceProvider",
  "collateralShareToken",
  "protectedShareToken",
  "debtShareToken",
  "maxLtv",
  "lt"
).annotations({ identifier: "MarketAssetMeta" });
